// extracted by mini-css-extract-plugin
export default {"wrapper":"FallbackLoader_wrapper__boR4t"};